import __request__ from "routing/request";
export function list(page = 1, per_page = 15, query, sort = "name", direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/detection_chains", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/detection_chains", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEventsForChain(name, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/detection_chains/events_for_chain/${name}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSummary(eventId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/detection_chains/summary_for_event/${eventId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/detection_chains/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/detection_chains/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(name, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/detection_chains/${name}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function disableChain(name, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/detection_chains/${name}/disable`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enableChain(name, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/detection_chains/${name}/enable`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
